import { render, staticRenderFns } from "./InsurerEdit.vue?vue&type=template&id=444f60d6&"
import script from "./InsurerEdit.vue?vue&type=script&lang=js&"
export * from "./InsurerEdit.vue?vue&type=script&lang=js&"
import style0 from "./InsurerEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports